import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'user-search',
  template: `
  <div class="tag-input-container">
    <tag-input matInput [formControl]="searchUserForm" [theme]="'minimal'" [placeholder]="'Search for a user'" [secondaryPlaceholder]="'Search for a user'" [maxItems]="1" 
            [editable]="true" [separatorKeyCodes]="[13, 32, 188]"
            [addOnBlur]="true" [addOnPaste]="true" (onAdd)="updateSearch()" (onRemove)="updateSearch()">
    </tag-input>
  </div>
  `,
  styles: [
    `
    .tag-input-container{
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .tag-input-container tag-input{
      width: 100%;
    }
    ::ng-deep .tag-input-container tag-input tag-input-form{
      width: 100%;
    }
    ::ng-deep .tag-input-container tag-input tag-input-form input{
      width: 100%;
    }
    `
  ]
})
export class UserSearchComponent implements OnInit {
    @Input() initialValue: string;
    @Output() searchChange = new EventEmitter<string>();
    searchUserForm: FormControl;

  constructor(
  ) {
    this.searchUserForm = new FormControl('');
  }
  ngOnInit(): void {
    if(this.initialValue){
        this.searchUserForm.setValue([{display: this.initialValue, value: this.initialValue}]);
    }
  }
  updateSearch(): void{
    const value = this.searchUserForm.value && this.searchUserForm.value.length > 0 ? this.searchUserForm.value[0].value : null;
    this.searchChange.emit(value);
  }
}
